'use client';

import { PostHogProvider } from '@posthog/react';
import posthog from 'posthog-js';
import { useEffect } from 'react';
import { useSession } from '../../lib/auth/client';

/** PostHog provider: init, replay, autocapture, identify user, automatic pageviews */
export function PHProvider({ children }: { children: React.ReactNode }) {
  const { data: session } = useSession();

  useEffect(() => {
    const key = process.env.NEXT_PUBLIC_POSTHOG_KEY;
    if (!key || typeof window === 'undefined') return;
    
    // Use proxy path for better reliability (less likely to be blocked)
    // Falls back to direct host if proxy is not configured
    const useProxy = process.env.NEXT_PUBLIC_POSTHOG_USE_PROXY !== 'false';
    const apiHost = useProxy ? '/ingest' : (process.env.NEXT_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com');
    
    posthog.init(key, {
      api_host: apiHost,
      ui_host: process.env.NEXT_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com',
      autocapture: true,
      disable_session_recording: false,
      session_recording: { maskAllInputs: true },
      defaults: '2025-11-30',
    });
  }, []);

  useEffect(() => {
    const user = session?.user;
    if (!user || !process.env.NEXT_PUBLIC_POSTHOG_KEY) return;
    posthog.identify(user.id, {
      email: user.email || undefined,
      name: user.name || undefined,
    });
  }, [session]);

  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
}

